//import LoginPage from "../views/Pages/LoginPage.jsx";

import Loadable from "react-loadable";
//import RegisterPage from "../views/Pages/RegisterPage.jsx";
//import LockScreenPage from "../views/Pages/LockScreenPage.jsx";
// import asyncComponent from '../components/AsyncComponent';
import React from "react";
import Spinner from "../elements/Spinner/Spinner";

let LoadableSpinner = () => <Spinner size="lg" fullScreen />;

// const AsyncResetPassword = Loadable({
//   loader: () =>
//     import("../views/Pages/ChangePassword" /* webpackChunkName: "chunk-loginPage" */),
//   loading: LoadableSpinner,
//   modules: ["chunk-resetPasswordPage"]
// });

const AsyncLoginPage = Loadable({
  loader: () =>
    import("../views/Pages/LoginPage" /* webpackChunkName: "chunk-loginPage" */),
  loading: LoadableSpinner,
  modules: ["chunk-loginPage"]
});

// const AsyncLoginPage = asyncComponent(() => import("../views/Pages/LoginPage"));

const AsyncRegisterPage = Loadable({
  loader: () =>
    import("../views/Pages/RegisterPage" /* webpackChunkName: "chunk-registerPage" */),
  loading: LoadableSpinner,
  modules: ["chunk-registerPage"]
});

// const AsyncRegisterPage = asyncComponent(() => import("../views/Pages/RegisterPage"));
// const AsyncLockScreenPage = Loadable({
//   loader: () =>
//     import('../views/Pages/LockScreenPage' /* webpackChunkName: "chunk-LockScreenPage" */),
//   loading: LoadableSpinner,
//   modules: ['chunk-LockScreenPage']
// });

// const AsyncLockScreenPage = asyncComponent(() => import("../views/Pages/LockScreenPage"));

var pagesRoutes = [
  // {
  //   path: "/pages/resetpassword-page/:token?",
  //   name: "Reset Password Page",
  //   mini: "CP",
  //   component: AsyncResetPassword
  // },
  {
    path: "/pages/login-page",
    name: "Login Page",
    mini: "LP",
    component: AsyncLoginPage
  },
  {
    path: "/pages/register-page/:firstName?/:name?/:email?/:refererFullName?",
    name: "Register",
    mini: "RP",
    component: AsyncRegisterPage
  }

  // {
  //   path: "/pages/lock-screen-page",
  //   name: "Lock Screen Page",
  //   mini: "LSP",
  //   component: AsyncLockScreenPage
  // }
];

export default pagesRoutes;
